import { render, staticRenderFns } from "./ModalUserLevel.vue?vue&type=template&id=39961c40"
import script from "./ModalUserLevel.vue?vue&type=script&lang=js"
export * from "./ModalUserLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports